var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCohorts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "assignment_ind_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M0,0H44V44H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M32.333,4.667H24.67a5.478,5.478,0,0,0-10.34,0H6.667A3.677,3.677,0,0,0,3,8.333V34a3.677,3.677,0,0,0,3.667,3.667H32.333A3.677,3.677,0,0,0,36,34V8.333A3.677,3.677,0,0,0,32.333,4.667ZM19.5,4.208a1.406,1.406,0,1,1-1.008.458A1.373,1.373,0,0,1,19.5,4.208ZM32.333,34H6.667V8.333H32.333ZM19.5,10.167a5.5,5.5,0,1,0,5.5,5.5A5.516,5.516,0,0,0,19.5,10.167Zm0,7.333a1.833,1.833,0,1,1,1.833-1.833A1.839,1.839,0,0,1,19.5,17.5ZM8.5,29.362v2.805h22V29.362c0-4.583-7.278-6.563-11-6.563S8.5,24.76,8.5,29.362Zm4.235-.862A12.854,12.854,0,0,1,19.5,26.447,12.8,12.8,0,0,1,26.265,28.5Z",
    transform: "translate(2.5 0.833)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohorts);
export default __webpack_public_path__ + "static/media/cohorts.6a78d6ff9c1b91dbcafb5fd3ffff7083.svg";
export { ForwardRef as ReactComponent };